import { api } from './index';

const BASE_PATH = '/api/internal/salaries';

export type Salary = {
  id: number;
  caregiverId: number;
  baseSalary: number;
  amountPerShift: number;
  minimumShiftsThreshold: number;
  startsOn: string;
  endsOn: string | null;
  humanStartsOn: string;
  humanEndsOn: string | null;
  active: boolean;
};

export interface SalaryForm {
  id?: number;
  caregiverId: number;
  baseSalary: number;
  amountPerShift: number;
  minimumShiftsThreshold: number;
  startsOn: string;
  endsOn?: string | null;
}

export const salariesApi = {
  index(caregiverId: number): Promise<Array<Salary>> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?caregiver_id=${caregiverId}`,
    }).then(response => response.data.salaries);
  },
  create(salaryForm: SalaryForm): Promise<Salary> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { salary: salaryForm },
    }).then(response => response.data.salary);
  },
  update(salaryForm: Partial<SalaryForm>): Promise<Salary> {
    if (!salaryForm.id) {
      return Promise.reject(new Error('Salary ID is required for update'));
    }
    return api({
      method: 'put',
      url: `${BASE_PATH}/${salaryForm.id}`,
      data: { salary: salaryForm },
    }).then(response => response.data.salary);
  },
  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    }).then(() => {});
  },
};
